/*
 * Lichte autoplay-video's (ROA, 23-10-2026), hoort bij snippets/roa-video.liquid.
 *
 * Een video krijgt pas een bron als hij echt te zien is: in beeld, niet verborgen
 * (de aparte desktop- en mobiele slideshow verbergen elkaar met display:none) en, in een
 * slideshow, alleen de actieve slide. Bron: tot 1080p; alleen bij databesparing de kleinere.
 * Wie minder beweging wil (prefers-reduced-motion) ziet alleen de poster.
 */
(function () {
  if (window.roaLazyVideo) return;
  window.roaLazyVideo = true;

  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var bespaar = navigator.connection && navigator.connection.saveData;
  var inBeeld = new WeakMap();

  function zichtbaar(video) {
    if (!video.getClientRects().length) return false;
    var slide = video.closest('.swiper-slide');
    return !slide || slide.classList.contains('swiper-slide-active');
  }

  function bijwerken(video) {
    if (inBeeld.get(video) && zichtbaar(video)) {
      if (rustig.matches) return;
      if (!video.getAttribute('src')) {
        var bron = bespaar ? video.dataset.srcSmall : video.dataset.srcLarge;
        if (!bron) return;
        video.src = bron;
      }
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } else if (!video.paused) {
      video.pause();
    }
  }

  var waarnemer = new IntersectionObserver(function (items) {
    items.forEach(function (item) {
      inBeeld.set(item.target, item.isIntersecting);
      bijwerken(item.target);
    });
  }, { rootMargin: '200px 0px' });

  var slideWaarnemer = new MutationObserver(function (mutaties) {
    mutaties.forEach(function (m) {
      m.target.querySelectorAll('video.roa-lazy-video').forEach(bijwerken);
    });
  });

  function start(root) {
    (root || document).querySelectorAll('video.roa-lazy-video').forEach(function (video) {
      if (video.dataset.roaKlaar) return;
      video.dataset.roaKlaar = '1';
      waarnemer.observe(video);
      var slide = video.closest('.swiper-slide');
      if (slide) slideWaarnemer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  window.addEventListener('resize', function () {
    document.querySelectorAll('video.roa-lazy-video').forEach(bijwerken);
  });
})();
